import { getImage, } from "../utils";
import { Category as ICategory } from "../types";

export default function Category({ category }: { category: ICategory }) {
  const imageUrl = getImage(category, "image", "small");
  const backgroundImage = typeof imageUrl === 'string' ? imageUrl : imageUrl.src;

  return (
    <div className="flex flex-col gap-2 md:gap-3 w-full h-full p-3 md:p-5 xl:p-6 text-left rounded-2xl shadowed">
      <div
        className="w-full aspect-square mt-2 bg-cover bg-center bg-no-repeat rounded-lg"
        style={{
          backgroundImage: `url(${backgroundImage})`
        }}
        role="img"
        aria-label={category.name}
      />
      <div className="d-block">
        <h3 className="text-lg md:text-xl xl:text-2xl font-medium font-heading ">{category.name}</h3>
      </div>
    </div>
  );
}
